import { AppSettings, EditionUpgradeAction } from '@galaxy/marketplace-apps';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { WebchatUpgradeCtaState } from '@galaxy/conversation/core';

export function webchatUpgradeCtaState(settings: AppSettings | null): WebchatUpgradeCtaState {
  const editionChange = settings?.editionChange;
  if (editionChange?.hideUpgradeCta) {
    return 'viewProduct';
  }
  return editionChange?.editionUpgradeAction === EditionUpgradeAction.EDITION_UPGRADE_ACTION_CONTACT_SALES
    ? 'contactUs'
    : 'getStarted';
}
